import Link from 'next/link';
import { FC } from 'react';
import { StaticImageData } from 'next/image';

import NextImage from '@/components/NextImage';
import Text from '@/components/Text';
import { twMerge } from 'tailwind-merge';
import { fonts } from '@/config';

interface BannerPropTypes {
  imageUrl: string | StaticImageData;
  title?: string | null;
  subTitle?: string | null;
  url?: string | null;
  urlText?: string | null;
  pathName?: string;
  classNames?: {
    root?: string;
  };
}

const PLPBanner: FC<BannerPropTypes> = ({
  imageUrl,
  title,
  subTitle,
  url,
  urlText,
  pathName,
  classNames,
}) => {
  const showGlassEffect = !!title || !!subTitle || !!urlText;
  const Children: FC = () => {
    return (
      <>
        <div className='relative aspect-26/43 h-full w-full max-w-76.5 pb-6 md:aspect-153/395'>
          <NextImage
            className='object-cover'
            alt={title ?? 'banner'}
            src={`${process.env.NEXT_PUBLIC_CDN_LINK}${imageUrl}`}
            fill
          />
          {showGlassEffect && (
            <div
              className={twMerge(
                'absolute bottom-0 mx-auto flex w-full flex-col items-start justify-start rounded-b-md bg-black/10 p-4 text-left text-white backdrop-blur-lg',
                fonts?.russolo?.className
              )}>
              {title && (
                <Text className='text-md px-0 font-semibold leading-tight text-white md:px-0 md:text-3xl'>
                  {title}
                </Text>
              )}
              {subTitle && (
                <Text className='px-0 text-white max-md:hidden md:px-0'>
                  {subTitle}
                </Text>
              )}
              {urlText && url && (
                <div className='cursor-pointer px-1 font-semibold text-fig underline max-md:text-sm'>
                  {urlText}
                </div>
              )}
            </div>
          )}
        </div>
        <div className='hidden h-full max-h-32 w-full bg-white md:block' />
      </>
    );
  };
  return url ? (
    <Link
      href={`${url}?breadcrumb=${pathName}`}
      passHref
      prefetch={false}
      className={twMerge(
        'col-span-1 row-span-1 flex h-full w-full max-w-76.5 flex-col md:row-span-2',
        classNames?.root
      )}>
      <Children />
    </Link>
  ) : (
    <div
      className={twMerge(
        'col-span-1 row-span-1 flex h-full w-full max-w-76.5 flex-col md:row-span-2',
        classNames?.root
      )}>
      <Children />
    </div>
  );
};

export default PLPBanner;
